import React from 'react';
import { useSelector } from 'react-redux';
import {
  bikeModelSelector,
  bikeColourSelector,
  getAllBikeAccessories,
  getPack,
  getSelectedServicePack,
  getSelectedWarrantyPack,
} from 'src/redux/bike/selectors';
import { getLanguageCode, roundPrecisionDecimal, stripHtmlTags } from 'helpers/utilities';
import {
  accessoryCategorySelector,
  accessoryCategoriesSelector,
  getAccessoriesQuery,
} from 'src/redux/configurator/selectors';
import useBikeTotal from '../useBikeTotal';

export default () => {
  const bikeTotal = useBikeTotal();

  const bikeModel = useSelector(bikeModelSelector);
  const bikeColour = useSelector(bikeColourSelector);
  const categories = useSelector(accessoryCategoriesSelector);
  const selectedCategory = useSelector(accessoryCategorySelector);
  const accessories = useSelector(getAllBikeAccessories);
  const accessoriesQuery = useSelector(getAccessoriesQuery);
  const accessoryPack = useSelector(getPack);
  const servicePack = useSelector(getSelectedServicePack);
  const warrantyPack = useSelector(getSelectedWarrantyPack);

  return {
    countryMarket: () => getLanguageCode(),
    configuratorBikeName: () => bikeModel && stripHtmlTags(bikeModel.name),
    configuratorBikeID: () => bikeModel && bikeModel.id,
    configuratorBikeYear: () => bikeModel && bikeModel.year,
    configuratorBikeColour: () => bikeColour && bikeColour.name,
    configuratorColourPrice: () => bikeColour && roundPrecisionDecimal(bikeColour.price - bikeModel.price),
    configuratorColourActions: () => '',
    configuratorAccessoryActions: () => '',
    configuratorAccessoryCategory: () => (selectedCategory ? selectedCategory.name : ''),
    configuratorAccessoryCategoryCount: () => categories.length,
    configuratorAccessoryID: () => '',
    configuratorAccessoryItems: () => accessories.length,
    configuratorAccessoryName: () => '',
    configuratorAccessoryPrice: () => '',
    configuratorAccessorySearch: () => accessoriesQuery,
    configuratorPackActions: () => '',
    configuratorPackID: () => accessoryPack?.id,
    configuratorPackName: () => accessoryPack?.name,
    configuratorPackPrice: () => accessoryPack?.price,
    configuratorStartPrice: () => bikeModel && bikeModel.price,
    configuratorFinalPrice: () => bikeTotal,
    configuratorTotalActions: () => '',
    configuratorValue: () => bikeModel && roundPrecisionDecimal(bikeTotal - bikeModel.price),
    configuratorGenre: () => (bikeModel && bikeModel.genre) || '',
    configuratorEngineRange: () => '',
    configuratorPriceRange: () => '',
    configuratorLicenceType: () => '',
    configuratorSurfaceType: () => '',
    configuratorProductCode: () => bikeModel && bikeModel.productCode,
    configuratorFilter: () => '',
    configuratorExtraName: () => warrantyPack?.title || servicePack?.title,
    configuratorExtraPrice: () => warrantyPack?.price || servicePack?.price,
    offerPresent: () => !!bikeModel?.offerSummaryContent?.title,
    offerName: () => bikeModel?.offerSummaryContent?.title,
    ctaText: () => '',
  };
};
